import { ReactNode } from 'react';

import { useAuth0 } from '@auth0/auth0-react';

import { GraphQlProvider } from '@chargeafter/providers';

import { initializeSecureHttpClientConfig } from './restClient';
import { environment } from './environment';

export type SecureHttpClientConfig = {
  merchantId?: string;
};

export type SecureDataProviderProps = {
  config?: SecureHttpClientConfig;
  children: ReactNode;
};
export const SecureDataProvider = ({
  children,
  config,
}: SecureDataProviderProps) => {
  const getAuth0Token = useAuth0().getAccessTokenSilently;
  initializeSecureHttpClientConfig(getAuth0Token, config);

  const graphQlProps = {
    url: `${environment.backendBaseUrl}/v2/operate/dynamic/graphql`,
    ...(config?.merchantId && {
      customHeaders: { 'x-ca-impersonate': config.merchantId },
    }),
  };

  return <GraphQlProvider {...graphQlProps}>{children}</GraphQlProvider>;
};
